import { Input, Space, Button } from 'antd';
import React, { useState } from 'react';

const useGetColumnTextSearchProps = (dataIndex) => {
    let [searchInput, setsearchInput] = useState("");
    let [searchedColumn, setsearchedColumn] = useState("");
    let [searchText, setSearchText] = useState("");

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        searchText = selectedKeys[0];
        searchedColumn = dataIndex;
      };
      const handleReset = clearFilters => {
        clearFilters();
        searchText = '';
      };
    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`Ara `}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        // icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Ara
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Sıfırla
                    </Button>
                    {/* <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({ closeDropdown: false });
                    searchText= selectedKeys[0];
                    searchedColumn= dataIndex;
                  }}
              >
                Filtre
              </Button> */}
                </Space>
            </div>
        ),
        // filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                text
            ) : (
                text
            ),
    }
}

export default useGetColumnTextSearchProps;